module.exports = __webpack_public_path__ + "static/media/CL.dfefa273.svg";